import {h, Fragment} from "preact"
import { IconFilters } from "../../icons"
import { useFiltersPanelState } from '../../../contexts/FiltersPanelStateContext'

export default function ButtonFilters () {

    const { openFilters } = useFiltersPanelState()

    return (
        <div className="flex-1 large--hide">
            <button className="btn flex align-items-center " onClick={event => {
                event.preventDefault()
                openFilters(true)
            }}>
                <span>Filters</span>
            </button>
        </div>
    )
}